<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择物料"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        hide-show-hide-btn
        url="baseMaterials">
      <template #toolbar>
        <el-alert
            title="模糊搜索用%代替，例如180%220"
            type="error"/>
      </template>
      <template #adSearch>
        <vm-search label="物料编号">
          <el-input v-model.trim="filter.no" clearable placeholder="请输入"/>
        </vm-search>
        <vm-search label="物料描述">
          <el-input v-model.trim="filter.name" clearable placeholder="请输入"/>
        </vm-search>
        <vm-search label="物料组">
          <el-input v-model.trim="filter.materialGroupNO" clearable placeholder="请输入"/>
        </vm-search>
        <vm-search label="是否可配置物料">
          <vm-dict-select v-model="filter.configurable" type="commonBoolean"/>
        </vm-search>
        <vm-search label="无料号">
          <el-checkbox v-model.trim="showNoIdMaterial" @change="selectNoIdMaterial"/>
        </vm-search>
      </template>
      <el-table-column prop="no" align="center" label="物料编号" width="100">
        <template #header>
          <el-input v-model.trim="filter.no" placeholder="物料编号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="name" align="center" label="物料描述" show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.name" placeholder="物料描述" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="materialGroupNO" align="center" label="物料组" width="100">
        <template #header>
          <el-input v-model.trim="filter.materialGroupNO" placeholder="物料组" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="productGroupNO" align="center" label="产品组" width="100"/>
      <el-table-column prop="purchaseGroupNO" align="center" label="采购组" width="100"/>
      <el-table-column prop="configurableFlagDesc" width="80" align="center" label="可配置物料"/>
      <el-table-column label="操作" align="center" width="120px">
        <template v-slot="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "MaterialSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        showNoIdMaterial:false,
        idList: "",
        filter: {
          parentId: "",
          keyWord: "",
          configurable: null,
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.showNoIdMaterial=false;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      selectNoIdMaterial() {
        let NoIdMaterial = {
          id: -1,
          name: "无料号",
          no: "无料号",
          price: "",
          unit: "",
        };
        if(this.showNoIdMaterial) {
          console.log(this.$refs.vmTable);
          this.$refs.vmTable._data.tableData = [];
          this.$refs.vmTable._data.tableData.push(NoIdMaterial);
        }else{
          this.$refs.vmTable.getList(1);
        }
      },
      onSelect(row) {
        //获取单个数据
        console.log(row);
        if(row.id === -1) {
          this.$emit("select", row);
          this.dialogVisible = false;
        }else {
          this.$http
            .get("basic", `baseMaterials/${row.id}`)
            .then(resp => {
              console.log(resp);
              row.propertyVOS = resp.propertyVOS;
              row.historyPrice = resp.historyPrice;
              this.$emit("select", row);
              this.dialogVisible = false;
            });
        }

        // this.$emit("select", row);
        // this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
